import { render, staticRenderFns } from "./TooltipMod.vue?vue&type=template&id=0ace82db"
import script from "./TooltipMod.vue?vue&type=script&lang=js"
export * from "./TooltipMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports